/*
 * @Author: hzm
 * @Date: 2022-12-14 14:12:16
 * @Description:
 */
/*
 * @Author: hzm
 * @Date: 2022-12-14 10:41:30
 * @Description:
 */
/*
 * @Author: hzm
 * @Date: 2022-07-08 08:13:23
 * @Description:
 */

// import { READSTATUS } from '@/api/portal/message/messageEnum';
// const message = {
//   state: {
//     msgNotReadCount: 0,
//     msgNotReadList: [],
//   },
//   mutations: {
//     setMsgNotReadCount: (state, data) => {
//       state.msgNotReadCount = data;
//     },
//     setMsgNotReadList: (state, data) => {
//       state.msgNotReadList = data;
//     },
//   },
//   actions: {
//     getUserNotReadMsgList({ commit }, queryParams) {
//       return new Promise((resolve, reject) => {
//         listForUser({
//           pageNum: 1,
//           pageSize: 5,
//           status: READSTATUS.NOTREAD,
//           ...queryParams,
//         }).then((res) => {
//           commit('setMsgNotReadCount', res.total);
//           commit('setMsgNotReadList', (res?.rows ?? []).splice(0, 5));
//           resolve(res);
//         });
//       });
//     },

//     //读取
//     readSingleMsg({ commit }, queryParams: { id?: string; messageId: string }) {
//       return new Promise((resolve, reject) => {
//         readMsg(queryParams).then((res) => {
//           resolve(res);
//         });
//       });
//     },

//     // 所有已读
//     readAllMsg({ commit }, queryParams: { id?: string; messageId: string }) {
//       return new Promise((resolve, reject) => {
//         readAllMsg().then((res) => {
//           resolve(res);
//         });
//       });
//     },
//   },
// };

// export default message;
import { listForUser, readMsg, readAllMsg } from '@/api/msgPush';

import { READSTATUS } from 'mroshopcommon';

import { defineStore } from 'pinia';
export const useMessageStore = defineStore('message', {
  state: () => ({
    msgNotReadCount: 0,
    msgNotReadList: [],
  }),
  getters: {},
  actions: {
    getUserNotReadMsgList(queryParams) {
      const self = this;
      return new Promise((resolve, reject) => {
        listForUser({
          pageNum: 1,
          pageSize: 5,
          status: READSTATUS.NOTREAD,
          ...queryParams,
        }).then(res => {
          self.msgNotReadCount = res.total;
          self.msgNotReadList = (res?.rows ?? []).splice(0, 5);
          resolve(res);
        });
      });
    },

    //读取
    readSingleMsg(queryParams: { id?: string; messageId: string }) {
      return new Promise((resolve, reject) => {
        readMsg(queryParams).then(res => {
          resolve(res);
        });
      });
    },

    readAllMsg() {
      return new Promise((resolve, reject) => {
        readAllMsg().then(res => {
          resolve(res);
        });
      });
    },
  },
});
